import { legalContainer } from '../../../Constants/Styles';
import { MetaIcon, LinkedInIcon, XIcon, YoutubeIcon } from '../../../Constants/Icons';
import { termsOfServiceUrl } from '../../../Constants/Data';

const Legal = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div className={legalContainer}> 
            <div className="flex flex-col sm:h-[60px] sm:flex-row items-center justify-center sm:mt-4 sm:mx-auto sm:w-[36rem] justify-between 2xl:hidden">
                <button className="pt-8 sm:pt-0  w-40">
                    <img src="https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/charmhealth-logo.png" alt="Charm Health" />
                </button>

                <h5 className="mt-2 text-white text-base font-semibold md:text-center">©{currentYear} MedicalMine Inc. All rights reserved.</h5>
            </div>

            <div className="2xl:mt-6 grid grid-cols-2 sm:flex sm:flex-row justify-between items-center">

                <button className="hidden xl:block w-40">
                    <img src="https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/charmhealth-logo.png" alt="Charm Health" />
                </button>

                <h5 className="hidden 2xl:block mt-2 text-white text-base font-semibold md:text-center">©{currentYear} MedicalMine Inc. All rights reserved.</h5>

                <a href={termsOfServiceUrl} target="_blank" rel="noopener noreferrer" className="w-fit">
                    <button className="w-fit text-white font-semibold">Terms of Service</button>
                </a>
                <div className="hidden md:block bg-white w-[1px] h-4"></div>


                <a href="https://www.charmhealth.com/privacy-policy.html" target="_blank" rel="noopener noreferrer" className="w-fit">
                    <button className="w-fit text-white font-semibold">Privacy Policy</button>
                </a>
                <div className="hidden md:block bg-white w-[1px] h-4"></div>

                <a href="https://www.charmhealth.com/security.html" target="_blank" rel="noopener noreferrer" className="w-fit">
                    <button className="w-fit text-white font-semibold">Security Policy</button>
                </a>
                <div className="hidden md:block bg-white w-[1px] h-4"></div>


                <a href="https://www.charmhealth.com/anti-spam-policy.html" target="_blank" rel="noopener noreferrer" className="w-fit">
                    <button className="w-fit text-white font-semibold">Anti-Spam Policy</button>
                </a>
                <div className="hidden md:block bg-white w-[1px] h-4"></div>

                <a href="https://www.charmhealth.com/cookie-policy.html" target="_blank" rel="noopener noreferrer" className="w-fit">
                    <button className="w-fit text-white font-semibold">Cookie Policy</button>
                </a>
            </div>

            <div className="mt-3 sm:mt-6 w-full flex justify-center">
                <div className=" flex flex-row gap-6 w-fit items-center">
                    <a href="https://www.facebook.com/charmhealth" target="_blank" rel="noopener noreferrer">
                        <MetaIcon />
                    </a>

                    <a href="https://www.linkedin.com/company/charmhealth" target="_blank" rel="noopener noreferrer" className="" >
                        <LinkedInIcon />
                    </a>

                    <a href="https://x.com/charmhealth" target="_blank" rel="noopener noreferrer" className="">
                        <XIcon />
                    </a>

                    <a href="https://www.youtube.com/charmhealth" target="_blank" rel="noopener noreferrer" className="">
                        <YoutubeIcon />
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Legal;